export default __webpack_public_path__ + "static/media/bg19.f50d2687.jpg";